const ConnectionsIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24" height="24" viewBox="0 0 24 24"
		fill="currentColor"
		stroke="none"
		{...props}
	>
		<path d="M12.3333 16.3333H7.33331L14.3333 2.33331V10.3333H19.3333L12.3333 24.3333V16.3333Z" />
		<path d="M5.38887 9.1667H2.33331L6.61109 0.611145V5.50003H9.66665L5.38887 14.0556V9.1667Z" />

	</svg>
)

export default ConnectionsIcon